<template>
  <div ref="preview">
    <!-- 图片预览 -->
    <div
      style="position:fixed;left:0;top: 0; width: 100vw; height: 100vh;z-index: 2000;"
      v-show="is_show_preview"
    >
      <div
        class="preview_zoom"
        style="background: #000;opacity: .8;position: absolute;left:0;top: 0;width: 100%;height: 100%;"
      ></div>
      <img
        :src="img_url"
        alt=""
        width="auto"
        height="80%"
        style="position: absolute;max-width: 100vw; left:50%;top:50%;z-index: 2;transform: translate(-50%, -50%);"
      />

      <Icon
        type="md-close"
        size="30"
        style="position: absolute;right: 60px;top: 60px;z-index: 2;cursor: pointer;"
        color="#eee"
        @click="is_show_preview = false"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "previewImage",
  props: {
    width: {
      type: String,
      default: "100px"
    },
    height: {
      type: String,
      default: "100px"
    },
    img_url: {
      type: String,
      default: "../../static/images/no_image.png"
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      is_show_preview: false
    };
  },
  mounted(){
    document.querySelector("body").appendChild(this.$refs.preview)
  },
  methods: {
    preview_image() {
      this.is_show_preview = true;
    }
  }
};
</script>

<style scoped lang="less">
.image_wrap {
  position: relative;
  background: center / contain no-repeat;
  .zoom {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0;
    transition: all 0.5s;
  }
  /deep/ .ivu-icon-md-eye,
  .preview_content,
  .preview_icon {
    transition: all 0.5s;
  }

  .preview_icon {
    opacity: 0;
    &:hover {
      /deep/ .ivu-icon-md-eye {
        color: #57a3f3 !important;
      }
      .preview_content {
        color: #57a3f3 !important;
      }
      // color: #57a3f3 !important;
      cursor: pointer;
    }
  }
  &:hover {
    .preview_icon {
      opacity: 1;
    }
    .zoom {
      opacity: 0.5;
      // cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/preview_image.vue